import { communityInboxChatQueries } from "@circle-react/lib/queries/communityInboxChats";
import { flatten, uniqBy } from "lodash";
import { useMemo } from "react";
import { useInfiniteQuery } from "react-query";

export const useAvatarChats = () => {
  const { data, fetchNextPage, hasNextPage, isPending } = useInfiniteQuery(
    communityInboxChatQueries.avatarChats(),
  );

  // Offset pages shift when a chat moves to the top between fetches.
  const chats = useMemo(
    () => uniqBy(flatten(data?.pages.map(page => page.records) ?? []), "id"),
    [data],
  );

  return { chats, fetchNextPage, hasNextPage, isPending };
};
